












export default
  data: ->
    usageCDN: """
      <xscript srt="https://cdn.jsdelivr.net/npm/vue"></xscript>
      <xscript src="https://cdn.jsdelivr.net/npm/rhoa/dist/rhoa.min.js"></xscript>
      <xscript>
        window.Rhoa.install(Vue, {})
      </xscript>
    """.replace /xscript/g, 'script'
    usageNPM1: """
      $ npm install rhoa --save
      # or
      $ yarn add rhoa
    """
    usageNPM2: """
      <template>
        <div class="main">
          <smart-link href="/logout" method="delete" text="Log out" is-reseted-style></smart-link>
        </div>
      </template>

      <xscript>
      import * as rhoa from 'rhoa'

      export default = {
        components: {
          'smart-link': rhoa.SmartLink
        }
      };
      </xscript>
    """.replace /xscript/g, 'script'



// WEBPACK FOOTER //
// ./node_modules/coffeelint-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-pug-lint-loader?{"disallowBlockExpansion":null,"disallowClassAttributeWithStaticValue":true,"disallowClassLiterals":null,"disallowClassLiteralsBeforeAttributes":null,"disallowClassLiteralsBeforeIdLiterals":true,"disallowDuplicateAttributes":true,"disallowHtmlText":true,"disallowIdAttributeWithStaticValue":true,"disallowIdLiterals":null,"disallowIdLiteralsBeforeAttributes":true,"disallowMultipleLineBreaks":true,"disallowSpacesInsideAttributeBrackets":true,"disallowSpecificAttributes":null,"disallowSpecificTags":["b","i"],"disallowStringConcatenation":true,"disallowStringInterpolation":true,"disallowTagInterpolation":true,"disallowTemplateString":true,"disallowTrailingSpaces":true,"maximumLineLength":180,"maximumNumberOfLines":80,"requireClassLiteralsBeforeAttributes":null,"requireClassLiteralsBeforeIdLiterals":null,"requireIdLiteralsBeforeAttributes":null,"requireLineFeedAtFileEnd":true,"requireLowerCaseAttributes":true,"requireLowerCaseTags":true,"requireSpacesInsideAttributeBrackets":null,"requireSpecificAttributes":null,"requireStrictEqualityOperators":true,"validateAttributeQuoteMarks":null,"validateAttributeSeparator":{"separator":", ","multiLineSeparator":",/n  "},"validateDivTags":true,"validateLineBreaks":"LF"}!./src/pages/Top/Usage.vue